export default __webpack_public_path__ + "static/NPN-2units-844d0484f2ef0682452fdc3a943ca378.png";